import Billboards from '../../../libs/API/Billboards';
import ImageModal from '../../../components/ImageModal';
import Alert from '../../../components/Alert';
import { gaSendEvent } from '../../../utils/Utils';

const ERROR_MSG_FILE_LIMITS = 'Image exceeds limit, please try an image less wide and less height.';
const ERROR_MSG_FILE_TYPE = 'Wrong file format, please select a .JPG or .PNG file format.';
const ERROR_MSG_FILE_SIZE = 'File size must be less than 5MB.';

class BillboardDetailImage {
    constructor(billboardId, hasArtworkPreview) {
        this.main = document.getElementById('billboard_detail_image');

        this._billboardId = billboardId;

        this._image = this.main.querySelector('.image');
        this._imageDefaultSrc = this._image.src;// Guardo en una variable la imagen original

        this._artworkHolder = this.main.querySelector('.artwork_holder')
        this._artworkInput = this.main.querySelector('.artwork_input');
        this._artworkUploadBtn = this.main.querySelector('.artwork_upload_btn');
        this._artworkSrcName = this.main.querySelector('.artwork_src_name');
        this._artworkClearBtn = this.main.querySelector('.artwork_clear_btn');

        this._fullscreenBtn = this.main.querySelector('.fullscreen_btn');
        this._downloadBtn = this.main.querySelector('.download_btn');

        this._artworkPreviewSrc = JSON.parse(localStorage.getItem('artwork_preview_src'));

        this._loadImage(hasArtworkPreview).then(() => {
            this._image.addEventListener('load', this._onLoadImage.bind(this));
            this._image.addEventListener('error', this._onErrorImage.bind(this));

            if (this._image.complete) {
                this._onLoadImage();
            }

            this._artworkInput.addEventListener('change', this._onArtworkInputChange.bind(this));
            this._artworkClearBtn.addEventListener('click', this._onClickArtworkClearBtn.bind(this))
            this._fullscreenBtn.addEventListener('click', this._onClickFullscreenBtn.bind(this));
            this._downloadBtn.addEventListener('click', this._onClickDownloadBtn.bind(this));
        }).catch((error) => {
            console.error(error);
        });
    }


    _onArtworkInputChange(e) {
        let files = this._artworkInput.files;
        let allowedExtensions = ['PNG', 'JPG', 'JPEG'];

        if (files.length > 0) {
            if (allowedExtensions.indexOf(files[0].name.split('.').pop().toUpperCase()) == -1) {
                Alert.show('warning', ERROR_MSG_FILE_TYPE, null, 'Ok');
            } else if (files[0].size > 5 * 1024 * 1024) {
                Alert.show('warning', ERROR_MSG_FILE_SIZE, null, 'Ok');
            } else {
                let formData = new FormData();
                formData.append('file', files[0]);


                this._artworkInput.disabled = true;
                this._artworkHolder.classList.remove('upload-artwork--uploaded');
                setTimeout(() => {
                    this._artworkUploadBtn.classList.add('button--loading');
                }, 250);

                gaSendEvent('Billboard Detail', 'Upload Artwork', 'Billboard Detail Image');

                fetch(`${BASE_URL}files/tmp`, {
                    method: 'post',
                    body: formData
                })
                    .then((response) => { return response.json() })
                    .then((data) => {
                        if (data.error) {
                            switch (data.errorType) {
                                case 'FILE_TYPE':
                                    Alert.show('warning', ERROR_MSG_FILE_TYPE, null, 'Ok');
                                    break;
                                case 'FILE_SIZE':
                                    Alert.show('warning', ERROR_MSG_FILE_SIZE, null, 'Ok');
                                    break;
                            }

                            if (this._artworkPreviewSrc != null) {
                                this._artworkHolder.classList.add('upload-artwork--uploaded');
                            }

                            this._artworkInput.disabled = false;
                            this._artworkUploadBtn.classList.remove('button--loading');
                        } else {
                            let artworkPreviewSrc = {
                                file: data.file,
                                name: files[0].name,
                                expires: new Date().getTime() + 4 * 3600 * 1000 // Suma 4 horas
                            }

                            this._artworkPreviewSrc = artworkPreviewSrc;
                            localStorage.setItem('artwork_preview_src', JSON.stringify(artworkPreviewSrc));

                            this._artworkSrcName.innerHTML = this._artworkPreviewSrc.name;

                            this._image.src = Billboards.getArtworkPreviewURL(this._billboardId, this._artworkPreviewSrc.file, 1080);
                        }
                    });

            }
        }
    }

    _onErrorImage(e = null) {
        this._artworkUploadBtn.classList.remove('button--loading');
        this._artworkInput.disabled = false;
        this._onClickArtworkClearBtn();
        Alert.show('warning', ERROR_MSG_FILE_LIMITS, null, 'Ok');
    }

    _onLoadImage(e = null) {
        this.main.classList.add('img-loader--loaded');

        if (this._artworkPreviewSrc != null) {
            this._artworkInput.disabled = false;
            this._artworkUploadBtn.classList.remove('button--loading');

            this._artworkHolder.classList.add('upload-artwork--uploaded');
        }
    }

    _onClickArtworkClearBtn(e) {
        this._artworkPreviewSrc = null;
        this._artworkSrcName.innerHTML = '';
        this._artworkInput.value = '';

        localStorage.removeItem('artwork_preview_src');

        this._artworkHolder.classList.remove('upload-artwork--uploaded');

        this._image.src = this._imageDefaultSrc;
    }

    _onClickFullscreenBtn(e) {
        e.preventDefault();

        ImageModal.show(this._image.src);
    }

    _onClickDownloadBtn(e) {
        e.preventDefault();

        window.open(Billboards.getArtworkPreviewDownloadURL(this._billboardId, this._artworkPreviewSrc.file), '_blank');
    }

    _loadImage(hasArtworkPreview) {
        let imageUrl = null;

        if (this._artworkPreviewSrc != null && hasArtworkPreview) {
            if (this._artworkPreviewSrc.expires < new Date().getTime()) {
                this._artworkPreviewSrc = null;
                localStorage.removeItem('artwork_preview_src');
            } else {
                this._artworkSrcName.innerHTML = this._artworkPreviewSrc.name;
                imageUrl = Billboards.getArtworkPreviewURL(this._billboardId, this._artworkPreviewSrc.file, 1080);
            }
        }

        return new Promise((resolve, reject) => {
            if (imageUrl) {
                this._image.src = imageUrl;

                this._image.onload = () => {
                    resolve(this._image);
                };

                this._image.onerror = () => {
                    reject(new Error(`Error loading image: ${imageUrl}`));
                };
            } else {
                resolve(true);
            }
        });
    }
}


export default BillboardDetailImage;